import { render, staticRenderFns } from "./tariffs.vue?vue&type=template&id=2a2ec42d"
import script from "./tariffs.vue?vue&type=script&lang=js"
export * from "./tariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports